/** 众议院州序（与 2014 data.js 下标一致，50 州） */
export const HOUSE_STATE = 'AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(
    ' ',
);

/** 众议院各州席位数（与 HOUSE_STATE 对齐） */
export const HOUSE_CHAIRS = [
    7, 1, 9, 4, 53, 7, 5, 1, 27, 14, 2, 2, 18, 9, 4, 4, 6, 6, 2, 8, 9, 14, 8, 4, 8, 1, 3, 4, 2, 12, 3, 27, 13, 1, 16, 5, 5,
    18, 2, 7, 1, 9, 36, 4, 1, 11, 10, 3, 8, 1,
];

/** 参议院有选举州序（含 OK/SC 特别选举 _OK _SC） */
export const SENATE_STATE = 'AL AK AR CO DE GA HI ID IL IA KS KY LA ME MA MI MN MS MT NE NH NJ NM NC OK _OK OR RI SC _SC SD TN TX VA WV WY'.split(
    ' ',
);

/** 州长有选举州序 */
export const GOVERNOR_STATE = 'AL AK AZ AR CA CO CT FL GA HI ID IL IA KS ME MD MA MI MN NE NV NH NM NY OH OK OR PA RI SC SD TN TX VT WI WY'.split(
    ' ',
);

export const STATE_NAMES = {
    AL: '亚拉巴马州',
    AK: '阿拉斯加州',
    AZ: '亚利桑那州',
    AR: '阿肯色州',
    CA: '加利福尼亚州',
    CO: '科罗拉多州',
    CT: '康涅狄格州',
    DE: '特拉华州',
    FL: '佛罗里达州',
    GA: '佐治亚州',
    HI: '夏威夷州',
    ID: '爱达荷州',
    IL: '伊利诺伊州',
    IN: '印第安纳州',
    IA: '艾奥瓦州',
    KS: '堪萨斯州',
    KY: '肯塔基州',
    LA: '路易斯安那州',
    ME: '缅因州',
    MD: '马里兰州',
    MA: '马萨诸塞州',
    MI: '密歇根州',
    MN: '明尼苏达州',
    MS: '密西西比州',
    MO: '密苏里州',
    MT: '蒙大拿州',
    NE: '内布拉斯加州',
    NV: '内华达州',
    NH: '新罕布什尔州',
    NJ: '新泽西州',
    NM: '新墨西哥州',
    NY: '纽约州',
    NC: '北卡罗来纳州',
    ND: '北达科他州',
    OH: '俄亥俄州',
    OK: '俄克拉何马州',
    OR: '俄勒冈州',
    PA: '宾夕法尼亚州',
    RI: '罗得岛州',
    SC: '南卡罗来纳州',
    SD: '南达科他州',
    TN: '田纳西州',
    TX: '德克萨斯州',
    UT: '犹他州',
    VT: '佛蒙特州',
    VA: '弗吉尼亚州',
    WA: '华盛顿州',
    WV: '西弗吉尼亚州',
    WI: '威斯康星州',
    WY: '怀俄明州',
    _OK: '俄克拉何马州（特别选举）',
    _SC: '南卡罗来纳州（特别选举）',
};

export const TAB_HOUSE = 0;
export const TAB_SENATE = 1;
export const TAB_GOVERNOR = 2;

export const TABS = [
    { key: TAB_HOUSE, label: '众议院', majority: 218, totalSeats: 435 },
    { key: TAB_SENATE, label: '参议院', majority: 51, totalSeats: 100 },
    { key: TAB_GOVERNOR, label: '州长', majority: 26, totalSeats: 50 },
];

/** 2014 scripts.js 配色 */
export const COLORS = {
    dem: '#004276',
    demLead: '#477493',
    gop: '#ac1e23',
    gopBar: '#b80000',
    gopLead: '#ca9090',
    other: '#7cad52',
    otherBar: '#78a752',
    otherLead: '#b8e2bc',
    pending: '#dddddd',
    tie: '#bfbfbf',
    none: '#dddddd',
};

export const ASSETS = {
    headerLogo: 'https://y1.ifengimg.com/a/2014/1104/header-logo.png',
    headerLogo2x: 'https://y1.ifengimg.com/a/2014/1104/header-logo@2x.png',
    headerBg: 'https://y1.ifengimg.com/a/2014/1104/header-bg.png',
    headerArrow: 'https://y1.ifengimg.com/a/2014/1104/header-continue-arrow.png',
    headerArrow2x: 'https://y1.ifengimg.com/a/2014/1104/header-continue-arrow@2x.png',
    ifengLogo: 'https://y1.ifengimg.com/a/2014/1104/ifeng-logo.png',
    ifengLogo2x: 'https://y1.ifengimg.com/a/2014/1104/ifeng-logo@2x.png',
    footerLogo: 'https://y1.ifengimg.com/a/2014/1104/footer-logo.png',
    footerLogo2x: 'https://y1.ifengimg.com/a/2014/1104/footer-logo@2x.png',
    legend: 'https://y1.ifengimg.com/a/2014/1104/house-legend.png',
    legend2x: 'https://y1.ifengimg.com/a/2014/1104/house-legend@2x.png',
    demLogo: 'https://y1.ifengimg.com/a/2014/1104/democratic-logo.png',
    demLogo2x: 'https://y1.ifengimg.com/a/2014/1104/democratic-logo@2x.png',
    gopLogo: 'https://y1.ifengimg.com/a/2014/1104/republican-logo.png',
    gopLogo2x: 'https://y1.ifengimg.com/a/2014/1104/republican-logo@2x.png',
    winBadge: 'https://y1.ifengimg.com/a/2014/1104/win-badge.png',
    otherArrow: 'https://y1.ifengimg.com/a/2014/1104/other-arrow.png',
    otherArrow2x: 'https://y1.ifengimg.com/a/2014/1104/other-arrow@2x.png',
    labelClose: 'https://y1.ifengimg.com/a/2014/1104/label-close.png',
};

export const POLL_INTERVAL_MS = 4000;

export const STATE_LISTS = [HOUSE_STATE, SENATE_STATE, GOVERNOR_STATE];

export const FILTER_ALL = 'all';
export const FILTER_DEM = 'democratic';
export const FILTER_GOP = 'republican';
